<div class="row">
	<div class="col-md-10">
		<ng-select
				name="selectedPanorama"
				[items]="items"
				*ngIf="items.length >0"
				ngDefaultControl
				[clearable]="false"
				bindLabel="name"
				(change)="changeComponentId()"
				[(ngModel)]="selectedItem">
		</ng-select>
	</div>
	<div class="col-md-2">
		<button class="btn btn-success btn-sm" (click)="openInsertModal()" style="position: absolute; top: 28%; left: 0;">
			<fa-icon [icon]="['fas','plus']"></fa-icon>
		</button>
	</div>
</div>
<ng-template #insertComponent let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Προσθήκη Μνημείου</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<app-monument-entity
				[siteId]="parentId"
				(monumentSave)="monumentSaved($event)"
				[hiddenButtons]="{deleteMonument: true, addMonument: true}"
				*ngIf="this.componentType === 'MONUMENT'">
		</app-monument-entity>
	</div>
</ng-template>